/** Phase AA4-FIX — log uncaught UI errors for Acharya debugging. */
let installed = false;

export function installAcharyaUiErrorLogging() {
  if (installed || typeof window === "undefined") return;
  installed = true;
  window.addEventListener("error", (e) => {
    console.log("UI Error:", e.error);
  });
  window.addEventListener("unhandledrejection", (e) => {
    console.log("UI Error:", e.reason);
  });
}
